import type { QueryClient } from '@tanstack/react-query';

/**
 * V4.9.3 — Standard query-cache invalidation after ANY ticket-mutating
 * action (Reassign, Change status, Change category, Log CX, Add note,
 * Handoff, Close ticket, Approve, Delete).
 *
 * Ensures every place the user might be looking refreshes instantly:
 * the ticket detail page header badges, the All Tickets list, My Queue,
 * Approvals queue, the Dashboard stat cards, Archives, Deleted view.
 *
 * Use this from every action mutation's `onSuccess` so that one click
 * to Reassign / Change status / etc. reflects everywhere at once. The
 * old pattern (each modal invalidating a different subset) was the cause
 * of the "I changed it but the badge at the top still shows the old
 * person" bug.
 */
export function invalidateAfterTicketAction(
  queryClient: QueryClient,
  ticketId?: string
): void {
  if (ticketId) {
    void queryClient.invalidateQueries({ queryKey: ['ticket', ticketId] });
  }
  // List + queue views
  void queryClient.invalidateQueries({ queryKey: ['tickets'] });
  void queryClient.invalidateQueries({ queryKey: ['myQueue'] });
  void queryClient.invalidateQueries({ queryKey: ['my-queue'] });
  void queryClient.invalidateQueries({ queryKey: ['approvals'] });
  // Dashboard cards / aggregations
  void queryClient.invalidateQueries({ queryKey: ['dashboard'] });
  void queryClient.invalidateQueries({ queryKey: ['workload'] });
  // Admin views
  void queryClient.invalidateQueries({ queryKey: ['archives'] });
  void queryClient.invalidateQueries({ queryKey: ['deleted'] });
}
